import { makeStyles } from "tss-react/mui";
import { Colors } from "./Colors";

export const useAddressIconStyle = makeStyles()(() => ({
  groupOrInvoiceAddressIcon: {
    height: 40,
    width: 28,
    color: Colors.gray,
  },
}));
